import React from 'react';
import { useApp } from '../context/AppContext';
import { CATEGORIES, PRODUCTS } from '../data/catalog';
import Icon from './Icon';
import './CategoryRail.css';

// 對應每個 MyCard 面額分組
const META = {
  all: { sample: ['mycard-150', 'mycard-300', 'mycard-1000', 'mycard-3000'], count: '7 種面額', desc: 'MyCard 全部面額' },
  small: { sample: ['mycard-50', 'mycard-150'], count: '50 / 150 點', desc: '小額試水 · 月卡入門' },
  medium: { sample: ['mycard-300', 'mycard-500'], count: '300 / 500 點', desc: '玩家熱銷面額' },
  large: { sample: ['mycard-1000', 'mycard-3000', 'mycard-5000'], count: '1K / 3K / 5K 點', desc: '大額儲值 · 省 5%' },
};

export default function CategoryRail() {
  const { lang, navigate } = useApp();
  return (
    <section className="section catrail">
      <div className="container">
        <div className="section-title">
          <div>
            <div className="eyebrow">面額選擇</div>
            <h2>挑選最適合您的 MyCard 面額</h2>
            <p className="lead">從 50 點入門到 5000 點大額儲值，7 種選擇</p>
          </div>
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => navigate('category', { id: 'all' })}
          >
            查看全部 <Icon name="arrowRight" size={14} />
          </button>
        </div>
        <div className="catrail__grid">
          {CATEGORIES.map((cat) => {
            const meta = META[cat.id];
            const samples = (meta.sample || [])
              .map((id) => PRODUCTS.find((p) => p.id === id))
              .filter(Boolean)
              .slice(0, 4);
            return (
              <button
                key={cat.id}
                className="catcard"
                onClick={() => navigate('category', { id: cat.id })}
              >
                <span className="catcard__name">{cat.name[lang] || cat.name['zh-TW']}</span>
                <span className="catcard__count">{meta.count}</span>
                <span className="catcard__chips">
                  {samples.map((p) => (
                    <span
                      key={p.id}
                      className="catcard__chip brand-tile"
                      style={{ '--brand-bg': p.bg }}
                      title={p.name}
                    >
                      <em>{p.logoText}</em>
                    </span>
                  ))}
                </span>
                <Icon name="arrowRight" size={14} className="catcard__arrow" />
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
